import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { contact } from "../src/landingPage/datasets/forms/contact";
import { meta } from "../src/landingPage/datasets/meta";
import { DiscoveryFormTemplate } from "../src/landingPage/views/Forms/templates/DiscoveryFormTemplate";
import { productsCatalogApi } from "../src/api/productsCatalogApi";

const ContactPage = ({ allDataSources }) => {
  return (
    <>
      <NextHead
        currentPath="/contact"
        title={meta.contact.title}
        description={meta.contact.description}
      />
      <DiscoveryFormTemplate
        type="contact"
        dataSources={allDataSources}
        data={contact}
        headerColor={contact.headerColor}
      />
    </>
  );
};

export const getServerSideProps = async () => {
  const sourcesData = await productsCatalogApi.getAllDataSources();
  const allDataSources = sourcesData?.data
    .filter(item => item.name.toLowerCase() !== "demystdata")
    .map(item => ({ item, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ item }) => item) // randomizing the order
    .slice(0, 30); // only take 30

  return {
    props: {
      allDataSources,
      wrapper: "MarketingWrapper",
    },
  };
};

export default ContactPage;
